import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
interface CTAButtonProps {
  text?: string;
  onClick?: () => void;
  href?: string;
  size?: 'lg' | 'xl';
  className?: string;
  showIcon?: boolean;
  pulse?: boolean;
}
export function CTAButton({
  text = 'QUIERO MI PACK COMPLETO',
  onClick,
  href = '#oferta',
  size = 'lg',
  className = '',
  showIcon = true,
  pulse = false
}: CTAButtonProps) {
  const baseClasses = 'inline-flex items-center justify-center font-bold rounded-full transition-all duration-300 shadow-lg hover:shadow-xl transform hover:-translate-y-0.5 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-[#D97706]';
  const sizeClasses = size === 'xl' ? 'px-8 py-4 text-xl md:text-2xl' : 'px-6 py-3 text-lg';
  const colorClasses = 'bg-[#D97706] hover:bg-[#B45309] text-white';
  const handleClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    if (onClick) onClick();
    // External URL — open in new tab
    if (href.startsWith('http://') || href.startsWith('https://')) {
      e.preventDefault();
      window.open(href, '_blank', 'noopener,noreferrer');
      return;
    }
    // Smooth scroll handling if it's an anchor link
    if (href.startsWith('#')) {
      e.preventDefault();
      const element = document.querySelector(href);
      if (element) {
        element.scrollIntoView({
          behavior: 'smooth'
        });
      }
    }
  };
  return <motion.div whileHover={{
    scale: 1.05
  }} whileTap={{
    scale: 0.95
  }} animate={pulse ? {
    boxShadow: ['0 0 0 0 rgba(217, 119, 6, 0.7)', '0 0 0 10px rgba(217, 119, 6, 0)']
  } : {}} transition={pulse ? {
    duration: 1.5,
    repeat: Infinity,
    repeatType: 'loop'
  } : {}} className="inline-block" data-id="element-63">
      <a href={href} onClick={handleClick} className={`${baseClasses} ${sizeClasses} ${colorClasses} ${className}`} data-id="element-64">
        {text}
        {showIcon && <ArrowRight className="ml-2 h-5 w-5 md:h-6 md:w-6" data-id="element-65" />}
      </a>
    </motion.div>;
}